import { ArrowUpRight, Sparkles } from "lucide-react";
import { CONTACT_EMAIL } from "@/lib/data";

export const Coaching = () => (
  <section className="py-16 md:py-20 bg-[#FFD1DC]/50" data-testid="coaching-section">
    <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8">
      <div className="bg-white border-2 border-black rounded-3xl p-7 md:p-10 shadow-brutal grid md:grid-cols-5 gap-8 items-center">
        <div className="md:col-span-3">
          <span className="font-sans text-sm font-bold tracking-[0.25em] uppercase text-[#8B5CF6]">
            Sur-mesure
          </span>
          <h2 className="mt-3 font-display text-4xl md:text-5xl leading-none uppercase">
            Coaching <br />
            <span className="italic">personnalisé.</span>
          </h2>
          <p className="mt-4 text-base md:text-lg text-[#1a1a1a] leading-relaxed">
            Un accompagnement individuel sur-mesure, taillé à vos objectifs : mouvement, expression scénique, prise de parole, libération corporelle. <strong>1h/semaine</strong> en studio, en extérieur ou à domicile — sur Saint-Jean-de-Luz et alentours.
          </p>
          <div className="mt-6 inline-flex items-center gap-2 bg-[#FFF3B0] border-2 border-black rounded-full px-4 py-2 shadow-brutal-sm">
            <Sparkles size={14} />
            <span className="font-sans text-xs font-bold tracking-widest uppercase">
              Premier échange offert
            </span>
          </div>
        </div>

        <div className="md:col-span-2 flex justify-end">
          <a
            href={`mailto:${CONTACT_EMAIL}?subject=Demande%20de%20coaching%20personnalis%C3%A9&body=Nom%20%3A%0AT%C3%A9l%C3%A9phone%20%3A%0ADisponibilit%C3%A9s%20%3A`}
            data-testid="coaching-cta"
            className="inline-flex items-center gap-2 bg-black text-white rounded-full px-6 py-4 font-sans font-bold hover:-translate-y-1 transition-transform"
          >
            Prendre contact
            <ArrowUpRight size={18} />
          </a>
        </div>
      </div>
    </div>
  </section>
);
